import React from 'react'

const Settings: React.FC = () => {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">Settings</h1>
        <p className="text-sm text-muted-foreground mt-1">Configure backoffice preferences</p>
      </div>
      
      <div className="bg-card border border-border rounded-md p-8 text-center">
        <p className="text-sm text-muted-foreground">Settings panel coming soon</p>
      </div>
    </div>
  )
}

export default Settings